module.exports = __webpack_public_path__ + "img/Craftbeauty-Viet-L.227481ec.jpg";